<script setup>
// Urun katalogu bolumunun kabugu: baslik + ust sekmeler + alt sayfa.
//
// Meta Ads kabugundan farkli olarak bilerek SADE tutuldu:
// katalog hesap genelindedir, bir reklam hesabina bagli degildir; bu yuzden
// hesap secici yok ve alt sayfalara prop gecilmiyor. Alt sayfalar kendi
// verisini /katalog uclarindan dogrudan ceker, kabuk arada veri tasimaz.
//
// Kenar cubugunda tek bir "Katalog" girisi durur; Urunler / Meta katalogu /
// Ice-Disa aktar ayrimi menuyu sismekten korumak icin buradaki sekmelerde.
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

// Sekme etiketleri dile bagli oldugu icin computed: dil degisince yenilensin.
const sekmeler = computed(() => [
  { ad: t('KATALOG.SEKME_URUNLER'), rota: 'katalog_urunler' },
  { ad: t('KATALOG.SEKME_META'), rota: 'katalog_meta' },
  { ad: t('KATALOG.SEKME_AKTARIM'), rota: 'katalog_aktarim' },
  { ad: t('KATALOG.SEKME_API'), rota: 'katalog_api' },
]);

const sekmeAktif = rota => route.name === rota;

// accountId rotadan tasinir: kabuk alt sayfalarla ayni hesapta kalmali.
const sekmeyeGit = rota =>
  router.push({ name: rota, params: { accountId: route.params.accountId } });
</script>

<template>
  <div class="flex flex-col w-full h-full overflow-hidden bg-n-surface-1">
    <header class="flex flex-col gap-3 px-6 pt-4 border-b border-n-weak">
      <h1 class="text-lg font-medium text-n-slate-12">
        {{ t('KATALOG.BASLIK') }}
      </h1>

      <!-- -mb-px: alt cizgi basligin kenarligiyla ust uste binsin -->
      <nav class="flex gap-1 -mb-px overflow-x-auto">
        <button
          v-for="s in sekmeler"
          :key="s.rota"
          type="button"
          class="px-3 py-2 text-sm whitespace-nowrap border-b-2 transition-colors"
          :class="
            sekmeAktif(s.rota)
              ? 'border-n-brand text-n-slate-12 font-medium'
              : 'border-transparent text-n-slate-11 hover:text-n-slate-12'
          "
          @click="sekmeyeGit(s.rota)"
        >
          {{ s.ad }}
        </button>
      </nav>
    </header>

    <div class="flex-1 overflow-auto">
      <RouterView />
    </div>
  </div>
</template>
